import RightChevron from "@/assets/colorable/right_chevron.svg?react";
import Loader from "@/components/Common/kpi/Loader";
import clsxm from "@/lib/clsxm";
import {memo, type FC} from "react";

const StepperArrow: FC<{
  direction: "LEFT" | "RIGHT";
  onClick?(): void;
  isDisabled?: boolean;
  className?: string;
  isLoading?: boolean;
  containerClassName?: string;
}> = ({direction, isDisabled, className, containerClassName, onClick, isLoading}) => {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled || isLoading}
      className={clsxm(
        "border-neutral-white-dark enabled:hover:border-primary-dark-solid flex h-8 w-8 items-center justify-center rounded-full border-2 bg-white transition-all duration-150 disabled:cursor-not-allowed",
        containerClassName,
      )}>
      {isLoading ? (
        <Loader
          styles={{
            loaderClassName: "h-4.5 w-4.5",
          }}
        />
      ) : (
        <RightChevron
          className={clsxm(
            "text-primary-dark-solid",
            {
              "rotate-180": direction === "LEFT",
              "text-neutral-white-dark": isDisabled,
            },
            className,
          )}
        />
      )}
    </button>
  );
};

export default memo(StepperArrow);
